import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

// --- CSS --- //
import "../../styles/header-public.css";

// --- ASSETS --- //
import logo from "../../assets/vert-cert-logo.png";
import MenuIcon from '@mui/icons-material/Menu';
import BusinessIcon from '@mui/icons-material/Business';
import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import HomeIcon from '@mui/icons-material/Home';

// --- COMPONENTS --- //
import Dropdown from "../Dropdown";

// --- FIREBASE --- //
import { getCurrentUser } from "../../utilities/auth/authUtils";
import Home from "../../paths/Public/Home";

const Header_Public = () => {
    // State to toggle dropdown visibility
    const [isDropdownVisible, setIsDropdownVisible] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const navigate = useNavigate();

    // Toggle dropdown handler
    const toggleDropdown = () => {
        setIsDropdownVisible((prev) => !prev);
    };

    // Update `isMobile` based on window size
    const updateIsMobile = () => {
        setIsMobile(window.innerWidth <= 768); // Adjust breakpoint as needed
    };

    const handleMouseEnter = () => {
        setIsDropdownVisible(true); // Show the dropdown when hovered
    };

    const handleMouseLeave = () => {
        setIsDropdownVisible(false); // Hide the dropdown when hover ends
    };

    useEffect(() => {
        // Set initial state and add event listener
        updateIsMobile();
        window.addEventListener("resize", updateIsMobile);

        if (getCurrentUser() != null) {
            setIsLoggedIn(true);
        }
        else {
            setIsLoggedIn(false);
        }

        // Cleanup event listener on unmount
        return () => {
            window.removeEventListener("resize", updateIsMobile);
        };
    }, []);

    useEffect(() => {

    }, []);

    // Dropdown menu items
    const dropdownItems = [
        { icon: <HomeIcon />, title: "HOME", link: "/" },
        { icon: <BusinessIcon />, title: "GYMS", link: "/gyms" },
        { icon: <EmojiPeopleIcon />, title: "CLIMBERS", link: "/climbers" },
        { icon: <AttachMoneyIcon />, title: "PRICING", link: "/pricing" },
        { icon: <ContactSupportIcon />, title: "CONTACT US", link: "/contact" },
    ];

    return (
        <>
            {/* HEADER */}
            <div id="header-container">
                {/* LOGO */}
                <div id="logo-container">
                    <a href="/"><img src={logo} alt="Vert Cert Logo" /></a>
                </div>
                <div id="public-right-header-content-container">
                    {/* MENU ITEMS (Desktop) */}
                    {!isMobile && (
                        <div id="menu-items-container">
                            {dropdownItems.map((item, index) => (
                                <div
                                    key={index}
                                    className="menu-item"
                                    onClick={() => navigate(item.link)}
                                    style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
                                >
                                    {item.icon}
                                    <span style={{ marginLeft: 8 }}>{item.title}</span>
                                </div>
                            ))}
                        </div>
                    )}

                    {/* ACCOUNT ICON (Mobile Only) */}
                    {isMobile && (
                        <div id="account-dropdown-container">
                            <span onClick={toggleDropdown} style={{ cursor: "pointer" }}>
                                <MenuIcon style={{ fontSize: 40, color: "var(--text-primary)" }} />
                            </span>
                        </div>
                    )}

                    {isLoggedIn && (
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <a href="/login"><AccountCircleIcon style={{ fontSize: 40, color: "var(--text-primary)", marginRight: "20px" }} /></a>
                        </div>
                    )}

                    {!isLoggedIn && (
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <a href="/waitlist"><button className="sign-up-button">Join Waitlist</button></a>
                            <a href="/login"><button className="sign-up-button" id="login-button">Log In</button></a>
                        </div>
                    )}
                </div>
            </div>

            {/* DROPDOWN MENU (Mobile Only) */}
            {isMobile && isDropdownVisible && (
                <Dropdown
                    items={dropdownItems.map((item) => ({
                        ...item,
                        onClick: item.onClick
                            ? item.onClick
                            : () => navigate(item.link), // Default navigation handler
                    }))}
                />
            )}
        </>
    );
};

export default Header_Public;